import { Icon } from '@chakra-ui/react';

export default function SFXMarkIconOutlined(props) {
  return (
    <Icon
      width={6}
      height={25}
      viewBox='0 0 24 25'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M12 24.4922C5.47266 24.4922 0.046875 19.0664 0.046875 12.5391C0.046875 6 5.46094 0.585938 11.9883 0.585938C18.5273 0.585938 23.9531 6 23.9531 12.5391C23.9531 19.0664 18.5391 24.4922 12 24.4922ZM12 22.5C17.5312 22.5 21.9609 18.0703 21.9609 12.5391C21.9609 7.00781 17.5195 2.57812 11.9883 2.57812C6.45703 2.57812 2.05078 7.00781 2.05078 12.5391C2.05078 18.0703 6.46875 22.5 12 22.5ZM7.99219 17.4961C7.47656 17.4961 7.05469 17.0742 7.05469 16.5469C7.05469 16.2891 7.16016 16.0664 7.33594 15.8906L10.6641 12.5508L7.33594 9.21094C7.16016 9.03516 7.05469 8.8125 7.05469 8.55469C7.05469 8.03906 7.47656 7.62891 7.99219 7.62891C8.26172 7.62891 8.47266 7.72266 8.64844 7.91016L11.9883 11.2383L15.3633 7.89844C15.5625 7.69922 15.7617 7.60547 16.0078 7.60547C16.5234 7.60547 16.9453 8.02734 16.9453 8.54297C16.9453 8.80078 16.8633 9 16.6641 9.19922L13.3242 12.5508L16.6523 15.8789C16.8398 16.0664 16.9336 16.2773 16.9336 16.5469C16.9336 17.0742 16.5117 17.4961 15.9961 17.4961C15.7266 17.4961 15.5039 17.3789 15.3281 17.2031L11.9883 13.875L8.67188 17.2031C8.49609 17.3906 8.26172 17.4961 7.99219 17.4961Z' />
    </Icon>
  );
}
